/*
 * @Description:
 */
/*
 * @Description:
 */
/*
 * @Description:
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userList: [],
    bussTypeList: [],
    butlerTypeList: [],
    companyTypeList: []
  },
  mutations: {
    updateUserList(state, payload){
      state.userList = payload
    },
    updateBussTypeList(state, payload){
      state.bussTypeList = payload
    },
    updateButlerTypeList(state, payload){
      state.butlerTypeList = payload
    },
    updateCompanyTypeList(state, payload){
      this.state.companyTypeList = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
